var mixin = require('../../../common/mixin');
var util = require('../../util/utility');
var getUA = require('../../../common/get-ua').internal;
var isAndroid =  (navigator.userAgent || '').match(/Android/i);

var ua = getUA();

function noop() {}

var batchAPI = [
    'setLLButton',
    'setLRButton',
    'setRLButton',
    'setRRButton'
];

var V2 = {
  'Copy': 1,
  'SMS': 2,
  'Email': 3,
  'Password': 4,
  'WeixinFriends': 10,
  'WeixinTimeline': 11,
  'QQ': 20,
  'Qzone': 21,
  'Weibo': 30,
  'Twitter': 10000,
  'Facebook': 10010,
  'Messenger': 10020,
  'Instagram': 10030,
  'Pinterest': 10040,
  'WhatsApp': 10050,
  'LINE': 10060
}

function _convertIcon(icon) {
    var mapList = {
        'H5_Favorite_On': 'ic_action_favorite_on_normal',
        'H5_Favorite_Off': 'ic_action_favorite_off_normal'
    };

    if (/android/i.test(ua.osName)) {
        return mapList[icon] || icon;
    }
    return icon;
}

function getChannel() {
  if(isAndroid){
      return {
        'WECHAT_FRIENDS': 0,
        'WECHAT_TIMELINE': 1,
        'QQ': 2,
        'QZONE': 3,
        'WEIBO': 4,
        'SMS': 5,
        'EMAIL': 6,
        'COPY': 7,
        V2: V2
      }
  } else {
      return {
          'WECHAT_FRIENDS': 0,
          'WECHAT_TIMELINE': 1,
          'QQ': 2,
          'SMS': 3,
          'WEIBO': 4,
          'QZONE': 5,
          'EMAIL': 6,
          'COPY': 7,
          V2: V2
      }
  }
}


var mappedAPI = batchAPI.map(function (api) {
  return {
    message: api,
    version: '9.2.0',
    mapper: function(opts){
      if (opts && opts.icon){
        opts.icon = _convertIcon(opts.icon);
      }

      return opts;
    }
  }
});

module.exports = [
  {
    version: '9.2.0',
    name: 'login',
    handler: function (opts) {
      var self = this;
      this.logout({
        success: function(){
          self.oldLogin(opts);
        }
      })
    }
  },
  {
    version: '9.2.0',
    message: 'login',
    name: 'oldLogin',
    mapper: function (opts) {
      var self = this;
      var originSuccess = opts.success || noop;
      var originFail = opts.fail || noop;
      // fix dp getuserinfo token 过期
      return mixin({}, opts, {
        success: function () {
          self.getUserInfo({
            success: function (ret) {
              originSuccess(mixin({}, ret, {
                type: 'dp',
                token: ret.token || ret.userToken,
                uuid: ret.dpid || ret.uuid
              }));
            },
            fail: function (err) {
              originFail(err);
            }
          })
        }
      });
    }
  },
  {
    version: '9.2.0',
    message: 'share',
    statics: getChannel(),
    mapper: function (opts) {
      opts = mixin({}, opts);
      opts.feed = opts.channel;
      if (!(opts.feed instanceof Array)) {
        opts.feed = [opts.feed];
      }
      if (opts.feed && opts.feed.length === 1) {
        opts.shareType = opts.feed[0];
      }

      if (opts.miniProgram && (/android/i.test(ua.osName))) {
        var miniProgram = opts.miniProgram;
        delete opts.miniProgram;
        return mixin(opts, {
          feed: util.parseFeed(opts.feed),
          url: util.tidyUrlParams(opts.url),
          miniProgramId: miniProgram.id,
          miniProgramPath: miniProgram.path,
          miniProgramImage: miniProgram.image,
          miniProgramType: miniProgram.type
        })
      } else {
        return mixin(opts, {
          feed: util.parseFeed(opts.feed),
          url: util.tidyUrlParams(opts.url)
        });
      }
    }
  },
  {
    version: '9.2.0',
    message: 'thirdLogin',
    handler: function(opts){
      var type = opts.type;
      var url;
      switch (type){
        case 1:
          url = location.protocol + '//m.dianping.com/auth/app?ft=15&sso=true';
          break;
        case 2:
          url = location.protocol + '//m.dianping.com/auth/app?ft=6&sso=true&redir=';
          break;
        case 3:
          url = location.protocol + '//m.dianping.com/auth/app?ft=5&ssp=true&redir=';
          break;
        case 4:
          url = location.protocol + '//m.dianping.com/auth/app?ft=2&source=1&sso=true&redir=';
          break;
      }
      this.openWebview({
        url: 'dianping://loginweb?url=' + encodeURIComponent(url) + '&isFromNative=true',
      });
    }
  },
  {
    version: '9.2.0',
    message: 'setSpotlight',
    mapper: function(opts){
      if (!opts.webpageURL) {
        return;
      }
      if (!opts.scheme) {
        opts.scheme = 'dianping://web?url=' + encodeURIComponent(opts.webpageURL);
      } 
      return opts;
    }
  },
  {
    version: '9.2.0',
    message: 'getUserInfo',
    mapper: function(opts){
      return mixin({}, opts, {
        success: function (result) { return opts.success(mixin(result, {
          type: 'dp',
          token: result.token || result.userToken,
          uuid: result.dpid || result.uuid
        })); }
      });
    }
  },
  {
    version: '9.2.0',
    name: 'getFingerprint',
    message: 'getCX',
    mapper: function(opts) {
      var success = opts.success || noop;
      opts.success = function(ret) {
        var fp = '';
        try {
          fp = JSON.parse(ret.fingerprint).fingerprint;
        }catch (ex){
          fp = ret.fingerprint;
        }
        success({
          fingerprint: fp
        });
      };
      return opts;
    },
  },
  {
    version: '9.2.0',
    name: 'getCity',
    message: 'getCityInfo',
    mapper: function(opts){
      return mixin({}, opts, {
        success: function (result) { return opts.success(mixin(result, { type: 'dp' })); }
      });
    }
  },
  {
    version: '9.2.0',
    name: 'getLocationCity',
    message: 'getCityInfo',
    mapper: function (opt) {
      console.warn('getLocationCity 桥已停止维护，请使用 getCity 桥替换，详情可联系 rencheng');
      return mixin({}, opt, {
        success: function (cityInfo) { return opt.success(mixin(cityInfo, {cityId: cityInfo.locCityId, cityName: cityInfo.locCityName, type: 'dp'})); }
      });
    }
  }
].concat(mappedAPI);



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/titans/dp/patch/9.2.0.js
// module id = 531
// module chunks = 0